import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import pathify from './pathify';
import Cookies from 'js-cookie';
import createMutationsSharer from 'vuex-shared-mutations';

Vue.use(Vuex);

// import modules
import modalsModule from './store/modules/modals.js';
import quoteModule from './store/modules/quote.js';
import quoteTempModule from './store/modules/quoteTemp.js';
import filtersModule from './store/modules/filters.js';
import resultsModule from './store/modules/results.js';
import upgradesModule from './store/modules/upgrades.js';
import customerModule from './store/modules/customer.js';
import cartModule from './store/modules/cart.js';
import paymentModule from './store/modules/payment.js';
import authModule from './store/modules/auth.js';

// persist store
const vuexLocal = new VuexPersistence({
  key: `${window.location.host || 'skyparksecure'}`,
  storage: window.sessionStorage,
  modules: ['modals', 'cart', 'quote', 'quoteTemp', 'results', 'filters', 'payment', 'upgrades']
})

const vuexCookie = new VuexPersistence({
  key: `${window.location.host || 'skyparksecure'}`,
  restoreState: (key) => Cookies.getJSON(key),
  saveState: (key, state) =>
  Cookies.set(key, state, {
    expires: 3
  }),
  modules: ['auth', 'customer'],
})

// init store
const store = new Vuex.Store({
  plugins: [pathify.plugin, vuexLocal.plugin, vuexCookie.plugin, createMutationsSharer({ predicate: ["payment/paymentInProgress"] })],
  modules: {
    modals: modalsModule,
    cart: cartModule,
    quote: quoteModule,
    quoteTemp: quoteTempModule,
    results: resultsModule,
    filters: filtersModule,
    customer: customerModule,
    payment: paymentModule,
    upgrades: upgradesModule,
    auth: authModule,
  }
});

export default store;